import React from "react";
import styles from "./Style.module.css";
const HREscalationMatrixView = () => {
  return (
    <div className={styles.container}>
      <div className={styles.logoImg}>
        <img
          src={require("../../assets/img/login logo@2x.png")}
       
          height={80}
          alt=""
        />
      </div>
      <div className={styles.loginSignupText}>
        <h1 className={styles.headingText}>HR Escalation Matrix</h1>
        <div className={styles.newLine} />
      </div>
<div className={styles.tableContainer}>

      <table className={styles.myTable}>
        <thead>
          <tr className={styles.centerText}>
            <th colSpan="4">Escalation Level I/III</th>
          </tr>
        </thead>

        <tbody>
          <tr className={styles.tableSubHeading}>
            <td>If you are joining at</td>
            <td>Name</td>
            <td>Contact</td>
            <td>Email Id</td>
          </tr>
          <tr className={styles.bgColorRow1}>
            <td>ISLL GBU, Derabassi</td>
            <td>Mr Surinder Sharma</td>
            <td>9915760189</td>
            <td>surinder.sharma@indswiftlabs.com</td>
          </tr>
          <tr className={styles.grayRow}>
            <td>ISLL Samba</td>
            <td>Mr Kamal Sharma</td>
            <td>9622283704</td>
            <td>admin.isl@indswiftlabs.com</td>
          </tr>
          <tr className={styles.bgColorRow1}>
            <td>Head Office</td>
            <td>Mr Rajesh Kumar</td>
            <td>9875924231</td>
            <td>hr.ho@indswiftlabs.com</td>
          </tr>
          <tr className={styles.grayRow}>
            <td>R&D</td>
            <td>Mr Mohit</td>
            <td>9056655607</td>
            <td>hrbp.rd@indswiftlabs.com</td>
          </tr>

          <tr className={styles.grayRow}>
            <td>Sales Field Force</td>
            <td>Mr Shobhit Sonkar</td>
            <td>7376288139</td>
            <td>Hrbp.ho2@indswiftlabs.com</td>
          </tr>
        </tbody>
      </table>
      <br />
     
      <table className={styles.myTable}>
        <thead>
          <tr className={styles.centerText}>
            <th colSpan="4">Escalation Level II/III</th>
          </tr>
        </thead>

        <tbody>
          <tr className={styles.tableSubHeading}>
            <td>If you are joining at</td>
            <td>Name</td>
            <td>Contact</td>
            <td>Email Id</td>
          </tr>
          <tr className={styles.bgColorRow1}>
            <td>Un-solved Payroll Queries</td>
            <td>Mr Rajesh Kumar</td>
            <td>9875924231</td>
            <td>hr.ho@indswiftlabs.com</td>
          </tr>
          <tr className={styles.bgColorRow1}>
            <td>Corporate Recruitments</td>
            <td>Ms Jyotsana Bekta</td>
            <td>9915109077</td>
            <td>hrbp.ho@indswiftlabs.com</td>
          </tr>
        </tbody>
      </table>



       <table className={styles.myTable}>
        <thead>
          <tr className={styles.centerText}>
            <th colSpan="4">Escalation Level III/III</th>
          </tr>
        </thead>

        <tbody>
          <tr className={styles.tableSubHeading}>
            <td>If you are joining at</td>
            <td>Name</td>
            <td>Contact</td>
            <td>Email Id</td>
          </tr>
          <tr className={styles.bgColorRow1}>
            <td>Vice President-HR</td>
            <td>Akashdeep Sharma</td>
            <td>9915752168</td>
            <td>akashdeep.sharma@indswiftlabs.com</td>
          </tr>
          
        </tbody>
      </table>
      <br />
   
</div>
    </div>
  );
};

export default HREscalationMatrixView;
